import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";

import Layout from "./../../../layouts/GuestLayout";
import PrivacyContainer from "./PrivacyContainer";
import LottieLoader from "../../../components/loaders/LottieLoader";
import guestService from "../../../services/guestService";

const PrivacyPolicy = () => {
    
    const [pageData, setPageData] = useState("");
    
    useEffect(() => {
        guestService.getPageContent('privacy-policy')
            .then((res) => {
                setPageData(res.data.page)
            })
    }, []);

    return (
        <>
            {pageData && (
                <Layout title="Privacy Policy">
                    <Helmet title="Mulk.pk | Privacy Policy" />

                    <PrivacyContainer
                        page={pageData}
                    />
                </Layout>
            )}
            {!pageData && <LottieLoader />}
        </>
    );
};

export default PrivacyPolicy;
